import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { GetCsCitiesDocument } from '~/graphql/generated/graphql';
import { searchCsClinicsPageInfoState } from '~/state/partials/search_cs_clinics/atoms';

export const useFetchCsCities = () => {
  const { prefectureCode } = useAtomValue(searchCsClinicsPageInfoState);
  const [getCsCities, { loading, data }] = useLazyQuery(GetCsCitiesDocument);

  useEffect(() => {
    if (prefectureCode) {
      getCsCities({
        variables: {
          prefectureCode,
        },
      });
    }
  }, [getCsCities, prefectureCode]);

  return {
    loading,
    csCities: data?.csCities || [],
  };
};
